module.exports = __webpack_public_path__ + "static/teaser_leistungen-e3120e25fbcf3a7c3a43356747a85358.svg";